/*!
 * GRT Youtube Popup - jQuery Plugin
 * Version: 1.0
 * Author: GRT107
 *
 * Copyright (c) 2017 GRT107
 * Released under the MIT license
*/

(function ($) {

  $.fn.grtyoutube = function (options) {

    return this.each(function () {
      this.style.cursor = 'pointer';
      // Get video ID
      let getvideoid = $(this).data('video-id');
      // Default options
      let settings = $.extend({
        videoID: getvideoid,
        autoPlay: true,
        theme: 'dark'
      }, options);

      // Convert some values
      if (settings.autoPlay === true) {
        settings.autoPlay = 1;
      } else if (settings.autoPlay === false) {
        settings.autoPlay = 0;
      }
      if (settings.theme === 'dark') {
        settings.theme = 'grtyoutube-dark-theme';
      } else if (settings.theme === 'light') {
        settings.theme = 'grtyoutube-light-theme';
      }

      // Initialize on click
      if (getvideoid) {
        $(this).on('click', function () {
          $('body').append('<div class="grtyoutube-popup ' + settings.theme + '">' +
            '<div class="grtyoutube-popup-content">' +
            '<span class="grtyoutube-popup-close"></span>' +
            '<iframe class="grtyoutube-iframe" src="https://www.youtube.com/embed/' + settings.videoID + '?rel=0&wmode=transparent&autoplay=' + settings.autoPlay + '&iv_load_policy=3" allowfullscreen frameborder="0" allow="autoplay; fullscreen"></iframe>' +
            '</div>' +
            '</div>');
        });
      }

      // Close the box on click or escape
      $(this).on('click', function (event) {
        event.preventDefault();
        $('.grtyoutube-popup-close, .grtyoutube-popup').click(function () {
          $('.grtyoutube-popup').remove();
        });
      });

      $(document).keyup(function (event) {
        if (event.keyCode == 27) {
          $('.grtyoutube-popup').remove();
        }
      });
    });
  };

}(jQuery));

jQuery(function ($) {
  function stickyHeader() {
    var $element = $('header'),
      elClassHidden = 'hidden',
      elClassSticky = 'sticky',
      throttleTimeout = 250;

    if (!$element.length) return true;

    var wHeight = 0,
      wScrollCurrent = 0,
      wScrollBefore = 0,
      wScrollDiff = 0,
      dHeight = 0,
      throttle = function (delay, fn) {
        var last, deferTimer;

        return function () {
          var context = this, args = arguments, now = +new Date;
          if (last && now < last + delay) {
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
              last = now;
              fn.apply(context, args);
            }, delay);
          } else {
            last = now;
            fn.apply(context, args);
          }
        };
      };

    $(window).on('scroll', throttle(throttleTimeout, function () {
      dHeight = $(document).height();
      wHeight = $(window).height();
      wScrollCurrent = $(window).scrollTop();
      wScrollDiff = wScrollBefore - wScrollCurrent;

      if (wScrollCurrent <= 0)
        $element.removeClass(elClassSticky).removeClass(elClassHidden);
      else if (wScrollDiff > 0 && $element.hasClass(elClassHidden))
        $element.addClass(elClassSticky).removeClass(elClassHidden);
      else if (wScrollDiff < 0) {
        if (wScrollCurrent + wHeight >= dHeight && $element.hasClass(elClassHidden))
          $element.addClass(elClassSticky).removeClass(elClassHidden);
        else
          $element.addClass(elClassHidden);
      }

      wScrollBefore = wScrollCurrent;
    }));
  }

  function submenuMaxHeight() {
    let windowHeight = $(window).height(),
      windowWidth = $(window).width(),
      banner = $('.top-banner'),
      header = $('header'),
      submenus = $('.submenu'),
      bannerHeight = $(window).scrollTop() > 0 ? 0 : banner.outerHeight(),
      headerHeight = header.outerHeight(),
      submenuHeight = windowHeight - bannerHeight - headerHeight;

    submenus.each(function () {
      let submenu = $(this);
      if (submenu.find('.submenu-container').outerHeight() > submenuHeight) {
        submenu.addClass('overflow');
      } else {
        submenu.removeClass('overflow');
      }

      if (windowWidth > 1080) {
        submenu.css({'max-height': submenuHeight});
      } else {
        submenu.css({'max-height': 'none'});
      }

      submenu.find('.brand-filter').css({'max-height': submenuHeight - 70});
    });
  }

  function submenuTop() {
    let topHeight = $('header .top-holder').outerHeight(),
      topBannerHeight = $('.top-banner').outerHeight(),
      bottomTop = topHeight + topBannerHeight,
      headerBottom = $('header .bottom'),
      sidebar = $('.archive-container aside');

    if ($('body').hasClass('admin-bar')) {
      bottomTop = bottomTop + 46;
    }

    if ($(window).outerWidth() <= 432) {
      headerBottom.css('top', bottomTop);
      sidebar.css('top', bottomTop);
    } else if ($(window).outerWidth() > 432 && $(window).outerWidth() <= 1080) {
      headerBottom.css('top', 100);
      sidebar.css('top', 100);
    } else {
      headerBottom.css('top', 0);
      sidebar.css('top', 0);
    }
  }

  function infoHeight() {
    $('.info-container, .archive-bottom').each(function () {
      if ($(this).children().length > 1) {
        let height = $(this).find('> *:first-child').outerHeight(),
          image = $(this).find('.image-box .image'),
          text = $(this).find('.text, .term-description');

        if (image.length) {
          image.remove('sticky');
        }

        if ($(window).width() > 1920) {
          height = height < 300 ? height * 2 : height;
          text.css({'max-height': height});
        } else if ($(window).width() > 667) {
          height = height < 150 ? height * 2 : height;
          text.css({'max-height': height});

        } else {
          text.css({'max-height': 'none'});
        }
      }
    });
  }

  $(document).ready(function () {

    stickyHeader();

    $('.menu-toggle').click(function () {
      $('html, body').toggleClass('hidden');
      $(this).toggleClass('close').parents('.top-holder').siblings('.bottom').slideToggle();
    });

    $('.search-toggle').click(function () {
      $('.search-form-container').toggle();
    });

    let subMenus = $('.has-submenu .sub-menu:not(.initialized)');
    subMenus.each(function () {
      let $submenu = $(this);

      let $submenuContainer = $('<div>', {class: 'submenu-container column-4'});
      let $submenuContainerLeft = $('<div>', {class: 'left'});
      let $menuItemBlock = null;

      $submenu.children().each(function (index, item) {
        if (index % 6 === 0) {
          $menuItemBlock = $('<div>', {class: 'menu-item-block'});
        }
        $('<div>', {class: 'menu-item', html: $(item).html()}).appendTo($menuItemBlock);
        $menuItemBlock.appendTo($submenuContainerLeft);
      });

      $submenu.replaceWith($('<div>', {class: 'submenu'}).append($submenuContainer.append($submenuContainerLeft)));
    });

    submenuMaxHeight();
    $(window).resize(submenuMaxHeight);
    $(window).scroll(submenuMaxHeight);

    submenuTop();
    $(window).resize(submenuTop);

    if ($('.top-banner').length) {
      var mainSlider = new Swiper('.top-banner .swiper-container', {
        effect: 'fade',
        loop: true,
        speed: 500,
        autoplay: {
          delay: 5000,
          // disableOnInteraction: false,
          // pauseOnMouseEnter: true
        },
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        }
      });
    }

    if ($('.slider-container').length) {
      var mainSlider = new Swiper('.slider-container .swiper-container', {
        effect: 'fade',
        loop: true,
        speed: 500,
        autoplay: {
          delay: 5000,
          // disableOnInteraction: false,
          // pauseOnMouseEnter: true
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: false
        }
      });
    }

    if ($('.cat-carousel').length) {
      var cats = new Swiper('.cat-carousel .swiper-container', {
        loop: true,
        speed: 500,
        // autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: false,
        //     pauseOnMouseEnter: true
        // },
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: false
        },
        breakpoints: {
          240: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          347: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          433: {
            slidesPerView: 4,
            spaceBetween: 10
          },
          505: {
            slidesPerView: 5,
            spaceBetween: 10
          },
          668: {
            slidesPerView: 6,
            spaceBetween: 10
          },
          897: {
            slidesPerView: 7,
            spaceBetween: 10
          },
          1921: {
            slidesPerView: 7,
            spaceBetween: 60
          }
        }
      });
    }

    if ($('.related-product-container').length) {
      var carousel = new Swiper('.carousel-container .carousel', {
        watchOverflow: true,
        slidesPerView: 'auto',
        spaceBetween: 12,
        speed: 500,
        /* autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },*/
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        },
      });
    } else if ($('.carousel-container').length) {
      var carousel = new Swiper('.carousel-container .carousel', {
        watchOverflow: true,
        speed: 500,
        /* autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },*/
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: false
        },
        breakpoints: {
          240: {
            slidesPerView: 1,
            spaceBetween: 12
          },
          433: {
            slidesPerView: 2,
            spaceBetween: 12
          },
          696: {
            slidesPerView: 3,
            spaceBetween: 12
          },
          933: {
            slidesPerView: 4,
            spaceBetween: 12
          },
          1921: {
            slidesPerView: 4,
            spaceBetween: 60
          }
        }
      });
    }

    if ($('.recent-posts').length) {
      var carousel = new Swiper('.recent-posts .swiper-container', {
        watchOverflow: true,
        speed: 500,
        // autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: false,
        //     pauseOnMouseEnter: true
        // },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: false
        },
        breakpoints: {
          240: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          433: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        }
      });
    }

    var scrollTop = $('.scroll-top');

    $(window).scrollTop() >= 100 && scrollTop.fadeIn(250);
    $(window).scroll(function () {
      $(window).scrollTop() <= '100' ? scrollTop.fadeOut(250) : scrollTop.fadeIn(250);
    });

    scrollTop.click(function () {
      $('html, body').animate({
        scrollTop: 0
      }, 300);
    });

    infoHeight();
    $(window).resize(infoHeight);

    if ($('.reviews-slider').length) {
      var reviewsSwiper = new Swiper($('.reviews-slider .swiper-container'), {
        loop: true,
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        speed: 500,
        // autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: false,
        //     pauseOnMouseEnter: true
        // },
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: false
        },
        breakpoints: {
          240: {
            slidesPerView: 1,
            spaceBetween: 0,
            coverflowEffect: {
              depth: 160,
              modifier: 2,
              rotate: 0,
              slideShadows: false,
              stretch: 102
            }
          },
          361: {
            slidesPerView: 1,
            spaceBetween: 0,
            coverflowEffect: {
              depth: 160,
              modifier: 2,
              rotate: 0,
              slideShadows: false,
              stretch: 115
            }
          },
          433: {
            slidesPerView: 1,
            spaceBetween: 0,
            coverflowEffect: {
              depth: 160,
              modifier: 2,
              rotate: 0,
              slideShadows: false,
              stretch: 172
            }
          },
          569: {
            slidesPerView: 1,
            spaceBetween: 0,
            coverflowEffect: {
              depth: 160,
              modifier: 2,
              rotate: 0,
              slideShadows: false,
              stretch: 232
            }
          },
          769: {
            slidesPerView: 2,
            spaceBetween: 0,
            coverflowEffect: {
              depth: 256,
              modifier: 2,
              rotate: 0,
              slideShadows: false,
              stretch: 67
            }
          },
          1921: {
            slidesPerView: 2,
            spaceBetween: 0,
            coverflowEffect: {
              depth: 300,
              modifier: 2,
              rotate: 0,
              slideShadows: false,
              stretch: 67
            }
          }
        }
      });
    }

    if ($('.category-slider').length && $('.category-slider .swiper-slide').length > 1) {
      var categorySwiper = new Swiper($('.category-slider .swiper-container'), {
        loop: true,
        speed: 500,
        // autoplay: {
        //     delay: 5000,
        //     // disableOnInteraction: false,
        //     pauseOnMouseEnter: false
        // },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: false
        }
      });
    }

    $('.product:not(.outofstock) .toggle-review-form').click(function () {
      $(this).next().slideToggle();
    });

    $('.stars a').on('mouseover', function () {
      var onStar = $(this).index() + 1;

      $(this).parent().children('a').each(function (e) {
        e < onStar ? $(this).addClass('filled') : $(this).removeClass('filled');
      });
    }).on('mouseout', function () {
      $(this).parent().children('a').each(function (e) {
        $(this).removeClass('filled');
      });
    });

    $('.stars a').on('click', function () {
      var activeStar = $(this).index() + 1,
        stars = $(this).parent().children('a');

      for (i = 0; i < stars.length; i++) {
        $(stars[i]).removeClass('selected');
      }

      for (i = 0; i < activeStar; i++) {
        $(stars[i]).addClass('selected');
      }

      $('#rating').find('option:nth-last-child(' + activeStar + ')').prop('selected', true).trigger('change');

      return false;
    });

    $('.single_add_to_cart_button').on('click', function () {
      if (!$(this).hasClass('disabled'))
        $(this).addClass('_loading');
    });

    $('.tooltip-on:not(.initialized)').each(function () {
      let title = $(this).attr('title');
      $(this).tooltip();
      $(this).addClass('initialized');
      $(this).attr('title', title);
    });
  });

  $(document).on('click touchstart', function (e) {
    var select = $('.select');

    if (!select.is(e.target) && select.has(e.target).length === 0) {
      select.find('.select-options').slideUp(300).prev().removeClass('active');
    }
  });

  const APP = {
    tabMobile: false,
    init: function () {
      let self = this;

      self.initHeader();
      self.initBrandTemplate();
      self.initFooter();

      self.woocommerceRadioButtons();
      self.woocommerceQuantity();
      self.woocommerceTabs();
    },
    woocommerceRadioButtons: function () {
      $('.variation-radio').change(function () {
        var variations_form = $('.variations_form'),
          selectedValue = $(this).val(),
          select = variations_form.find('select');

        if (selectedValue) {
          select.val(selectedValue).trigger('change');
          variations_form.trigger('woocommerce_variation_select_change');
          variations_form.trigger('check_variations');
        }
      });
    },
    woocommerceQuantity: function () {
      if (!String.prototype.getDecimals) {
        String.prototype.getDecimals = function () {
          let num = this,
            match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);

          if (!match) {
            return 0;
          }

          return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
        };
      }

      $(document.body).on('click', '.dec, .inc', function () {
        let $this = $(this),
          $qty = $this.siblings('.quantity').find('.qty'),
          currentVal = parseFloat($qty.val()),
          max = parseFloat($qty.attr('max')),
          min = parseFloat($qty.attr('min')),
          step = $qty.attr('step');

        if (!currentVal || currentVal === '' || currentVal === 'NaN') {
          currentVal = 0;
        }
        if (max === '' || max === 'NaN') {
          max = '';
        }
        if (min === '' || min === 'NaN') {
          min = 0;
        }
        if (step === 'any' || step === '' || step === undefined || parseFloat(step) == 'NaN') {
          step = '1';
        }

        if ($this.is('.inc')) {
          if (max && currentVal >= max) {
            $qty.prop('disabled', true).attr('disabled', 'disabled');
            $qty.val(max);
          } else {
            $qty.prop('disabled', false).removeAttr('disabled');
            $qty.val((currentVal + parseFloat(step)).toFixed(step.getDecimals()));
          }
        } else {
          if (min && currentVal <= min) {
            $qty.prop('disabled', true).attr('disabled', 'disabled');
            $qty.val(min);
          } else if (currentVal > 0) {
            $qty.prop('disabled', false).removeAttr('disabled');
            $qty.val((currentVal - parseFloat(step)).toFixed(step.getDecimals()));
          }
        }

        $qty.trigger('change');
        // $(document).trigger('wc_update_cart');
        // $('button[name="update_cart"]').click();
      });
    },
    woocommerceTabs: function () {
      let self = this;

      $('.woocommerce-tabs li a').off('click').click(function (e) {
        let $this = $(this).parent(),
          $tab = $($(this).attr('href'));

        if (!$tab.length) {
          return;
        }

        e.preventDefault();

        if ($this.hasClass('active')) {
          $this.removeClass('active');
          $tab.slideUp();
        } else {
          $('.woocommerce-tabs li').removeClass('active');
          $('.woocommerce-Tabs-panel:visible').slideUp();
          $this.addClass('active');
          $tab.slideDown();
        }

        return false;
      });
    },
    initBrandTemplate: function () {
      const $BrandTemplate = $('.brands-template');
      if (!$BrandTemplate.length) {
        return;
      }

      let $brandsTabs = $('.brand-tabs');
      let $brandsTabsOffsetTop = $brandsTabs[0].offsetTop;
      let $brandsTabsHeight = $brandsTabs[0].offsetHeight;
      let $brandsItems = $('.brands').children();

      function activateTab(href) {
        let $target = $('.brand[data-target=' + href + ']'),
          $destination = $('.brand-tab[data-target=' + href + ']');
        if (!$target.length || !$destination.length) {
          return;
        }

        $destination.addClass('current').siblings().removeClass('current');
        $('html, body').animate({
          scrollTop: $($target).offset().top - 20
        }, 500);
      }

      $(window).load(function () {
        let hash = window.location.hash;

        if (hash) {
          let href = hash.replace('#', '');
          activateTab(href);
        }
      });
      $('.brands-template .alphabet .letter').click(function () {
        activateTab($(this).text());
      });

      $('.brands-template .brand-tab').click(function () {
        activateTab($(this).data('target'));
      });

      function activateStickyTabs() {
        if ($(window).scrollTop() + $brandsTabsHeight > $brandsTabsOffsetTop) {
          $('.brand-tabs').addClass('sticky').css({
            'height': $brandsTabsHeight + 'px',
          });
        } else {
          $('.brand-tabs').removeClass('sticky').css({
            'height': 'auto',
          });
        }

        if ($('.brand-tabs').hasClass('sticky')) {
          let current;
          $brandsItems.each(function (index, item) {
            if ($(window).scrollTop() - item.offsetTop <= 15) {
              current = item;
              return false;
            }
          });

          if (current) {
            $(current).addClass('current').siblings().removeClass('current');
            $('.brand-tab[data-target=' + current.dataset.target + ']').addClass('current').siblings().removeClass('current');
          }
        } else {
          $brandsItems.removeClass('current');
          $('.brand-tab').removeClass('current');
        }
      }

      // $(window).load(function () {
      //     activateStickyTabs();
      // });
      //
      // $(window).scroll(function () {
      //     activateStickyTabs();
      // });
    },
    initHeader: function () {
      const $SubMenu_0 = $('.has-submenu');
      if ($SubMenu_0.length) {
        $SubMenu_0.append('<div class="submenu-toggle"><i class="icon icon-arrow-down"></i></div>');

        $SubMenu_0.on('click', '.submenu-toggle', function () {
          $(this).toggleClass('active').prev().slideToggle().parent().siblings('.has-submenu').find('.submenu').slideUp().next().removeClass('active');
        });
      }

      const $SubMenu_1 = $('.submenu .children');
      if ($SubMenu_1.length) {
        $SubMenu_1.append('<div class="toggle-children"><i class="icon icon-arrow-down"></i></div>');

        $SubMenu_1.on('click', '.toggle-children', function () {
          $(this).toggleClass('active').prev().slideToggle();

          let $submenu = $('.submenu');
          if ($('.submenu-container').outerHeight() > $submenu.outerHeight()) {
            $submenu.addClass('overflow');
          } else {
            $submenu.removeClass('overflow');
          }
        });
      }
    },
    initFooter: function () {
      $('footer .block:not(:nth-last-child(2)) .title').click(function () {
        if ($(window).outerWidth() > 1080) {
          return false;
        }
        $(this).toggleClass('active').next().slideToggle()
          .parent().siblings('.block:not(:nth-last-child(2))').find('.title').removeClass('active').next().slideUp();
      });
    },
  };

  APP.init();

  const GTAG4 = {
    _isLocalhost: false,
    default_data: {
      currency: 'UAH',
    },
    isLocalhost: function () {
      if (this._isLocalhost === null) {
        this._isLocalhost = window.location.hostname.indexOf('.local') >= 0;
      }
      return this._isLocalhost;
    },
    init: function () {
      let self = this;

      self.viewProductPage();
      // self.add_payment_info();
      // self.add_shipping_info();
      self.add_to_cart();
      self.add_to_wishlist();
      self.begin_checkout();
      self.login();
      self.purchase();
      self.remove_from_cart();
      self.search();
      // self.select_item();
      self.sign_up();
      self.view_cart();
      // self.view_item();
      // self.view_item_list();
    },
    gtag: function (event, action, data) {
      let self = this;
      // if (self.isLocalhost()) {
      //     console.log(event, action, data);
      // } else {
      gtag(event, action, data);
      // }
    },
    viewProductPage: function () {
      let self = this;

      if ($(document.body).hasClass('single-product')) {
        self.gtag('event', 'view_item', $('.product[data-gtag]').data('gtag'));
      }
    },
    add_payment_info: function () {
      gtag('event', 'add_payment_info', {
        currency: 'USD',
        value: 30.03,
        coupon: 'SUMMER_FUN',
        payment_type: 'Credit Card',
        items: [
          {
            item_id: 'SKU_12345',
            item_name: 'Stan and Friends Tee',
            affiliation: 'Google Merchandise Store',
            coupon: 'SUMMER_FUN',
            discount: 2.22,
            index: 0,
            item_brand: 'Google',
            item_category: 'Apparel',
            item_category2: 'Adult',
            item_category3: 'Shirts',
            item_category4: 'Crew',
            item_category5: 'Short sleeve',
            item_list_id: 'related_products',
            item_list_name: 'Related Products',
            item_variant: 'green',
            location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
            price: 10.01,
            quantity: 3
          }
        ]
      });
    },
    add_shipping_info: function () {
      gtag('event', 'add_shipping_info', {
        currency: 'USD',
        value: 30.03,
        coupon: 'SUMMER_FUN',
        shipping_tier: 'Ground',
        items: [
          {
            item_id: 'SKU_12345',
            item_name: 'Stan and Friends Tee',
            affiliation: 'Google Merchandise Store',
            coupon: 'SUMMER_FUN',
            discount: 2.22,
            index: 0,
            item_brand: 'Google',
            item_category: 'Apparel',
            item_category2: 'Adult',
            item_category3: 'Shirts',
            item_category4: 'Crew',
            item_category5: 'Short sleeve',
            item_list_id: 'related_products',
            item_list_name: 'Related Products',
            item_variant: 'green',
            location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
            price: 10.01,
            quantity: 3
          }
        ]
      });
    },
    add_to_cart: function () {
      let self = this;

      let $addToCart = $('.add_to_cart_gtag');
      if ($addToCart.length) {
        self.gtag('event', 'add_to_cart', $addToCart.data('gtag'));
      }
    },
    add_to_wishlist: function () {
      let self = this;
      $(document.body).on('click', '.add_to_wishlist', function () {
        let data = $(this).parents('.product-card:first').data('gtag');
        if (typeof data === 'undefined') {
          data = $(this).parents('.product[data-gtag]:first').data('gtag');
        }

        if (typeof data === 'undefined') {
          return;
        }
        self.gtag('event', 'add_to_wishlist', data);
      });
    },
    begin_checkout: function () {
      let self = this;

      let $viewCheckout = $('.view_checkout_gtag');
      if ($viewCheckout.length) {
        self.gtag('event', 'begin_checkout', $viewCheckout.data('gtag'));
      }
    },
    generate_lead: function () {

    },
    login: function () {
      let self = this;

      $(document.body).on('submit', '.woocommerce-form-login', function () {
        self.gtag('set', 'user_properties', {
          'email': $('input[name="username"]').val()
        });
        self.gtag('event', 'login', {
          method: 'My Account page'
        });
      });
    },
    purchase: function () {
      let self = this;

      let $viewPurchase = $('.view_purchase_gtag');
      if ($viewPurchase.length) {
        let data = $viewPurchase.data('gtag');
        self.gtag('set', 'user_properties', {
          'first_name': data.customer_first_name,
          'last_name': data.customer_last_name,
          'email': data.customer_email,
          'phone': data.customer_phone,
        });
        self.gtag('event', 'purchase', data);
      }
    },
    refund: function () {
      gtag('event', 'refund', {
        currency: 'USD',
        transaction_id: 'T_12345', // Transaction ID. Required for purchases and refunds.
        value: 30.03,
        coupon: 'SUMMER_FUN',
        shipping: 3.33,
        tax: 1.11,
        items: [
          {
            item_id: 'SKU_12345',
            item_name: 'Stan and Friends Tee',
            affiliation: 'Google Merchandise Store',
            coupon: 'SUMMER_FUN',
            discount: 2.22,
            index: 0,
            item_brand: 'Google',
            item_category: 'Apparel',
            item_category2: 'Adult',
            item_category3: 'Shirts',
            item_category4: 'Crew',
            item_category5: 'Short sleeve',
            item_list_id: 'related_products',
            item_list_name: 'Related Products',
            item_variant: 'green',
            location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
            price: 10.01,
            quantity: 3
          }
        ]
      });
    },
    remove_from_cart: function () {
      let self = this;
      $(document.body).on('click', '.cart_item a.remove', function () {
        self.gtag('event', 'remove_from_cart', $(this).parent().parent().data('gtag'));
      });
    },
    search: function () {
      let self = this;

      $(document.body).on('submit', '.search-form', function () {
        self.gtag('event', 'search', {
          search_term: $('input.search-input').val()
        });
      });
    },
    select_item: function () {
      gtag('event', 'select_item', {
        item_list_id: 'related_products',
        item_list_name: 'Related products',
        items: [
          {
            item_id: 'SKU_12345',
            item_name: 'Stan and Friends Tee',
            affiliation: 'Google Merchandise Store',
            coupon: 'SUMMER_FUN',
            discount: 2.22,
            index: 0,
            item_brand: 'Google',
            item_category: 'Apparel',
            item_category2: 'Adult',
            item_category3: 'Shirts',
            item_category4: 'Crew',
            item_category5: 'Short sleeve',
            item_list_id: 'related_products',
            item_list_name: 'Related Products',
            item_variant: 'green',
            location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
            price: 10.01,
            quantity: 3
          }
        ]
      });
    },
    sign_up: function () {
      let self = this;

      $(document.body).on('submit', '.woocommerce-form-register', function () {
        self.gtag('set', 'user_properties', {
          'email': $('input[name="username"]').val()
        });
        self.gtag('event', 'sign_up', {
          method: 'My Account page'
        });
      });
    },
    select_promotion: function () {

    },
    view_cart: function () {
      let self = this;

      let $viewCart = $('.view_cart_gtag');
      if ($viewCart.length) {
        self.gtag('event', 'view_cart', $viewCart.data('gtag'));
      }
    },
    view_item: function () {
      let self = this;
      gtag('event', 'view_item', {
        currency: self.default_data.currency,
        value: 30.03,
        items: [
          {
            item_id: 'SKU_12345',
            item_name: 'Stan and Friends Tee',
            affiliation: 'Google Merchandise Store',
            coupon: 'SUMMER_FUN',
            discount: 2.22,
            index: 0,
            item_brand: 'Google',
            item_category: 'Apparel',
            item_category2: 'Adult',
            item_category3: 'Shirts',
            item_category4: 'Crew',
            item_category5: 'Short sleeve',
            item_list_id: 'related_products',
            item_list_name: 'Related Products',
            item_variant: 'green',
            location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
            price: 10.01,
            quantity: 3
          }
        ]
      });
    },
    view_item_list: function () {
      gtag('event', 'view_item_list', {
        item_list_id: 'related_products',
        item_list_name: 'Related products',
        items: [
          {
            item_id: 'SKU_12345',
            item_name: 'Stan and Friends Tee',
            affiliation: 'Google Merchandise Store',
            coupon: 'SUMMER_FUN',
            discount: 2.22,
            index: 0,
            item_brand: 'Google',
            item_category: 'Apparel',
            item_category2: 'Adult',
            item_category3: 'Shirts',
            item_category4: 'Crew',
            item_category5: 'Short sleeve',
            item_list_id: 'related_products',
            item_list_name: 'Related Products',
            item_variant: 'green',
            location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
            price: 10.01,
            quantity: 3
          }
        ]
      });
    },
    view_promotion: function () {
      gtag('event', 'view_promotion', {
        creative_name: 'Summer Banner',
        creative_slot: 'featured_app_1',
        promotion_id: 'P_12345',
        promotion_name: 'Summer Sale',
        items: [
          {
            item_id: 'SKU_12345',
            item_name: 'Stan and Friends Tee',
            affiliation: 'Google Merchandise Store',
            coupon: 'SUMMER_FUN',
            creative_name: 'summer_banner2',
            creative_slot: 'featured_app_1',
            discount: 2.22,
            index: 0,
            item_brand: 'Google',
            item_category: 'Apparel',
            item_category2: 'Adult',
            item_category3: 'Shirts',
            item_category4: 'Crew',
            item_category5: 'Short sleeve',
            item_list_id: 'related_products',
            item_list_name: 'Related Products',
            item_variant: 'green',
            location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
            price: 10.01,
            promotion_id: 'P_12345',
            promotion_name: 'Summer Sale',
            quantity: 3
          }
        ]
      });
    }
  };
  const FBQ = {
    _isLocalhost: false,
    default_data: {
      currency: 'UAH',
    },
    isLocalhost: function () {
      if (this._isLocalhost === null) {
        this._isLocalhost = window.location.hostname.indexOf('.local') >= 0;
      }
      return this._isLocalhost;
    },
    init: function () {
      let self = this;

      self.ViewContent();
      self.AddToCart();
      self.AddToWishlist();
      self.InitiateCheckout();
      self.Lead();
      self.Purchase();
      self.CompleteRegistration();
    },
    sendEvent: function (event, action, data) {
      fbq(event, action, data);
    },
    ViewContent: function () {
      let self = this;

      if ($(document.body).hasClass('single-product')) {
        self.sendEvent('track', 'ViewContent', $('.product[data-fbq]').data('fbq'));
      }
    },
    AddToCart: function () {
      let self = this;

      let $addToCart = $('.add_to_cart_fbq');
      if ($addToCart.length) {
        self.sendEvent('track', 'AddToCart', $addToCart.data('fbq'));
      }
    },
    AddToWishlist: function () {
      let self = this;
      $(document.body).on('click', '.add_to_wishlist', function () {
        let data = $(this).parents('.product-card:first').data('fbq');
        if (typeof data === 'undefined') {
          data = $(this).parents('.product[data-gtag]:first').data('fbq');
        }

        if (typeof data === 'undefined') {
          return;
        }

        self.sendEvent('track', 'AddToWishlist', data);
      });
    },
    InitiateCheckout: function () {
      let self = this;

      let $viewCheckout = $('.view_checkout_fbq');
      if ($viewCheckout.length) {
        self.sendEvent('track', 'InitiateCheckout', $viewCheckout.data('fbq'));
      }
    },
    Lead: function () {
      let self = this;

      let $viewLead = $('.view_lead_fbq');
      if ($viewLead.length) {
        self.sendEvent('track', 'Lead', $viewLead.data('fbq'));
      }
    },
    Purchase: function () {
      let self = this;

      let $viewPurchase = $('.view_purchase_fbq');
      if ($viewPurchase.length) {
        self.sendEvent('track', 'Purchase', $viewPurchase.data('fbq'));
      }
    },
    CompleteRegistration: function () {
      let self = this;

      $(document.body).on('submit', '.woocommerce-form-register', function () {
        self.sendEvent('track', 'CompleteRegistration', {
          currency: 'UAH',
          value: 0,
        });
      });
    },
  };

  $(document).ready(function () {
    GTAG4.init();
    FBQ.init();
  });
});
